module.exports = __webpack_public_path__ + "media/images/home/ourpurpose-bg-82852c2fe486b13aaa24a3d6b14f85e9.jpg";